import React from "react";
import { ClientChannelConfiguration } from "@shared/types";
import { AccountData } from "@shared/features/onboarding/types";

export const GroupOverviewContext = React.createContext<
  | {
      signalsGroupId: number | undefined;
      setSignalsGroupId: (signalsGroupId: number) => void;
      displayedConfiguration: ClientChannelConfiguration | undefined;
      setDisplayedConfiguration: (
        displayedConfiguration: ClientChannelConfiguration | undefined
      ) => void;
      selectedConfiguration: ClientChannelConfiguration | undefined;
      setSelectedConfiguration: (
        selectedConfiguration: ClientChannelConfiguration | undefined
      ) => void;
      selectedAccountId: number | undefined;
      setSelectedAccountId: (selectedAccountId: number | undefined) => void;
      accounts: AccountData[] | undefined;
      setAccounts: (accounts: AccountData[] | undefined) => void;
    }
  | undefined
>(undefined);
